import { useState, useEffect } from 'react';
import { User } from 'src/types';
import { useUserService } from 'src/context';

const useDefaultUser = () => {
  const userService = useUserService();
  const [defaultUser, setDefaultUser] = useState<User>();

  useEffect(() => {
    const fetchUserDropDown = async () => {
      try {
        const defaultUser = await userService.getDefaultUser();
        setDefaultUser(defaultUser);
      } catch (err) {
        console.warn('Error fetching user data');
      }
    };

    fetchUserDropDown();
  }, [userService]);

  return { defaultUser };
};

export { useDefaultUser };
